module.exports = __webpack_public_path__ + "images/emoji/clock10.f8b679f1de5fe1b542bf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock10.png
// module id = UGAg
// module chunks = 14